import { TLD } from '../types';

// TODO remove this hardcoded dependency
export const MAIN_CATEGORIES = {
  de: [
    '/wohnen',
    '/schlafen',
    '/essen',
    '/bad',
    '/kinder',
    '/flur',
    '/buero',
    '/garten',
    '/lampen',
    '/heimtextilien',
    '/dekoration',
    '/baumarkt',
  ],
  fr: [
    '/sejour',
    '/chambre',
    '/cuisine-et-salle-a-manger',
    '/salle-de-bain',
    '/enfant-et-bebe',
    '/couloir',
    '/bureau',
    '/jardin',
    '/luminaire',
    '/linge-de-maison',
    '/deco-maison',
    '/bricolage',
  ],
  nl: [
    '/woonkamer',
    '/slaapkamer',
    '/keuken-en-eetkamer',
    '/badkamer',
    '/kinderkamer',
    '/hal-en-gang',
    '/kantoor',
    '/tuin',
    '/lampen',
    '/textiel',
    '/deco',
    '/bouwmarkt',
  ],
};

export function isCategoryPage(url: string, market: TLD): boolean {
  if (!url) {
    return false;
  }
  const [path] = url.split('?');
  const [mainCategoryPath] = path.replace(/^\/*/, '').split('/');
  return MAIN_CATEGORIES[market].includes(`/${mainCategoryPath}`);
}
